import { useTranslation } from "react-i18next";
import { FaMinus } from "react-icons/fa";
import { GoPlus } from "react-icons/go";
import { ReactComponent as FarmIcon } from "../../../../assets/svg/icons/farmIcon.svg";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { getLocale } from "../../../../i18n";

interface InfoRainfallProps {
  task: ITaskRainfall;
}

export default function InfoRainfall({ task }: InfoRainfallProps) {
  const { t } = useTranslation();
  const rainfall = Number.isFinite(task.rainfall_mm)
    ? new Intl.NumberFormat(getLocale(), { maximumFractionDigits: 20 }).format(task.rainfall_mm)
    : "—";

  return (
    <section className="rainfallDetails">
      <div>
        <span>{t("taskDetails.rainfall.onFarm")}</span>
        <div className="rainfallFarm">
          <FarmIcon className="rainfallFarmIcon" />
          <div className="labelInitialTaskInfo">
            <span>{task.initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="rainfallQuestion">
        <div className="balloon pointed">{t("taskDetails.rainfall.prompt")}</div>
        <div className="rainfallMeasurement">
          <span id="rainfall-value-label">{t("taskDetails.rainfall.amount")}</span>
          <div className="rainfallCounter" role="group" aria-labelledby="rainfall-value-label">
            <span className="rainfallCounterIcon" aria-hidden="true"><FaMinus /></span>
            <output aria-label={t("taskDetails.rainfall.amount")}>{rainfall}</output>
            <span className="rainfallCounterIcon" aria-hidden="true"><GoPlus /></span>
          </div>
        </div>
      </div>
    </section>
  );
}
